import { apiUrl, fetchWithTimeout } from "./api";

const ADMIN_TOKEN_KEY = "admin_jwt";

export const loginAdmin = async (email, password) => {
  const response = await fetchWithTimeout(apiUrl("/api/auth/login"), {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ email, password }),
  });

  const data = await response.json().catch(() => null);

  if (!response.ok) {
    throw new Error(data?.error || "Invalid email or password");
  }

  const token = data?.token || data?.data?.token;
  if (!token) {
    throw new Error("Login succeeded but no admin token was returned");
  }

  return { ...data, token };
};

export const getAdminToken = () => {
  if (typeof window === "undefined") {
    return null;
  }

  return window.localStorage.getItem(ADMIN_TOKEN_KEY);
};

export const setAdminToken = (token) => {
  if (!token) {
    clearAdminToken();
    return;
  }
  window.localStorage.setItem(ADMIN_TOKEN_KEY, token);
};

export const clearAdminToken = () => {
  window.localStorage.removeItem(ADMIN_TOKEN_KEY);
};

export const isAdminAuthenticated = () => Boolean(getAdminToken());
